import React, { FC } from 'react';

import { styled } from '../theme';
import FlexRow from './FlexRow';
import H1 from './H1';
import { useModal } from './Modal';
import SvgIcon from './SvgIcon';

const HeaderWrapper = styled(FlexRow)`
    border-bottom: none;
    text-align: center;
    font-size: 2.6rem;
    padding: 40px 40px 0;
    margin-bottom: -10px;
    justify-content: space-between;
    position: relative;
`;
const Title = styled(FlexRow)`
    margin: 0 auto;
`;
const CloseButton = styled(SvgIcon)`
    z-index: 2;
    position: absolute;
    cursor: pointer;
    top: 18px;
    right: 40px;
    opacity: 0.2;
    transition: opacity 0.2s ease;
    :hover {
        opacity: 0.5;
    }
`;
type Props = {
    children?: React.ReactNode;
    closeButton?: boolean;
    className?: string;
};
const ModalHeader: FC<Props> = ({ children, closeButton, className }) => {
    const { onHide } = useModal();
    return (
        <HeaderWrapper align="center" className={className}>
            <Title>
                <H1>{children}</H1>
            </Title>
            {closeButton && <CloseButton src="/icons/ic-cross.svg" alt="close" onClick={onHide} />}
        </HeaderWrapper>
    );
};
export default ModalHeader;
